import { useState, useRef, useEffect } from "react";

type ActionItem = {
  label: string;
  icon?: React.ReactNode | string;
  onClick: () => void;
  className?: string;
};

export default function ActionMenu({ actions }: { actions: ActionItem[] }) {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(e: MouseEvent) {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="relative inline-block" ref={ref}>
      <button
        onClick={() => setOpen(!open)}
        className="px-2 py-1 text-xs bg-blue-100 text-blue-700 rounded-md hover:bg-blue-200"
      >
        ⋮
      </button>

      {open && (
        <div className="absolute right-0 mt-2 w-75 bg-white shadow-lg rounded-md border border-gray-200 z-20">
          {actions.map((action, index) => (
            <button
              key={index}
              onClick={() => {
                setOpen(false);
                action.onClick();
              }}
              className={`w-full text-left px-3 py-2 hover:bg-gray-100 text-sm flex items-center gap-2 ${
                action.className || ""
              }`}
            >
              {action.icon} {action.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
